import { Collapse, Flex, Text } from '@mantine/core';
import { IconChevronDown } from '@tabler/icons-react';
import cn from 'classnames';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import BaseClickable from '@/components/ui/BaseClickable';
import { useLocalStore } from '@/hooks/useLocalStore';
import { OpenStore } from '@/stores/local/shared/OpenStore';
import { useSidebarNewsStore } from '@/stores/local/sidebar/SidebarNewsStore';

import s from './NewsCategories.module.scss';

const NewsCategories: React.FC = () => {
  const { categoriesStore } = useSidebarNewsStore();
  const { isOpen, toggle } = useLocalStore(() => new OpenStore(true));

  if (categoriesStore.categories.length === 0) {
    return null;
  }

  return (
    <div className={s.root}>
      <BaseClickable block className={cn(s.root__header, isOpen && s.root__header_opened)} onClick={toggle}>
        <Text fw={500} size="md">
          Категории
        </Text>
        <IconChevronDown size={16} stroke={1.5} className={cn(s.root__chevron, isOpen && s.root__chevron_opened)} />
      </BaseClickable>
      <Collapse in={isOpen} transitionDuration={120} transitionTimingFunction="ease-out" className={s.root__collapse}>
        <Flex className={s.root__group} wrap="wrap">
          {categoriesStore.categories.map((category) => {
            const isSelected = categoriesStore.isSelected(category.key);

            return (
              <BaseClickable
                key={category.key}
                value={category.key}
                onClickWithValue={categoriesStore.toggle}
                className={cn(s.root__badge, isSelected && s.root__badge_selected)}
              >
                <Text size="xs" fw={500}>
                  {category.value}
                </Text>
              </BaseClickable>
            );
          })}
        </Flex>
      </Collapse>
    </div>
  );
};

export default observer(NewsCategories);
